import Vue from 'vue';
import Regions from '../config/regions';
import { DataService } from './data.service';
//import { URLService } from 'url.service'

export class RegionsService {
	constructor(options) {
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());

		gtag('config', 'G-3G3YQDVFV0');
		
		this.dataService = new DataService();
		let vm = this;

		options = options || {};
		let urlService = options.urlService.initialParams;


		//state selector

		vm.stateSelector = new Vue({
			el: '#states',
			data: {
				selectedState: "",
				states: Regions.States
			},
			methods: {
				change: function () {
					gtag('event', 'select', {
						'event_category': 'CCAP Landcover Atlas',
						'event_label': this.selectedState.StateName,
						'value': this.selectedState.StateName
					});

					vm.countySelector.counties = this.selectedState.Counties;
					vm.countySelector.selectedCounty = "";

					// vm.watershedSelector.watersheds = this.selectedState.Watersheds;
					// vm.watershedSelector.selectedWatershed = "";
				}
			}
		});


		vm.regionTypeSelector = new Vue({
			el: '#regionType',
			data: {
				regionType: 'counties'
			},
			methods: {
				change: function () {
					//console.log(`Selected Region Type ${this.regionType}`)
					vm.countySelector.isHidden = this.regionType !== 'counties';
					// vm.watershedSelector.isHidden = this.regionType === 'counties';
					//vm.refreshAppData();
				}
			}
		});

		//county selector
		vm.countySelector = new Vue({
			el: '#counties',
			data: {
				isHidden: false,
				selectedCounty: "",
				counties: []
			},
			methods: {
				change: function () {
					//console.log(`Selected County: ${this.selectedCounty.Name} GeoID: ${this.selectedCounty.GeoId}`);
					vm.selectedLocation.state = vm.stateSelector.selectedState.StateName;
					vm.selectedLocation.stateFIPS = vm.stateSelector.selectedState.StateFIPS;
					vm.selectedLocation.location = this.selectedCounty.Name;
					vm.fromYearSelector.years = this.selectedCounty.Years;
					vm.fromYearSelector.selectedYear = this.selectedCounty.Years[0];
					vm.toYearSelector.years = this.selectedCounty.Years;
					vm.toYearSelector.selectedYear = this.selectedCounty.Years[this.selectedCounty.Years.length - 1];
					vm.refreshAppData();
				}
			}
		});

		//watershed selector
/*
		vm.watershedSelector = new Vue({
			el: '#watersheds',
			data: {
				isHidden: true,
				selectedWatershed: "",
				watersheds: []
			},
			methods: {
				change: function () {
					//console.log(`Selected Watershed: ${this.selectedWatershed.Name} GeoID: ${this.selectedWatershed.GeoId}`);
					vm.selectedLocation.state = vm.stateSelector.selectedState.StateName;
					vm.selectedLocation.stateFIPS = vm.stateSelector.selectedState.StateFIPS;
					vm.selectedLocation.location = this.selectedWatershed.Name;
					vm.fromYearSelector.years = this.selectedWatershed.Years;
					vm.fromYearSelector.selectedYear = this.selectedWatershed.Years[0];
					vm.toYearSelector.years = this.selectedWatershed.Years;
					vm.toYearSelector.selectedYear = this.selectedWatershed.Years[this.selectedWatershed.Years.length - 1];
					vm.refreshAppData();
				}
			}
		});
*/

		vm.fromYearSelector = new Vue({
			el: '#fromYear',
			data: {
				selectedYear: "",
				years: []
			},
			methods: {
				change: function () {
					//console.log(`Selected From Year: ${this.selectedYear}`);
					if (vm.fromYearSelector.selectedYear >= vm.toYearSelector.selectedYear){
						vm.toYearSelector.selectedYear = this.years[this.years.indexOf(vm.fromYearSelector.selectedYear) + 1];
					}
					vm.refreshAppData();
				}
			}
		});

		vm.toYearSelector = new Vue({
			el: '#toYear',
			data: {
				selectedYear: "",
				years: []
			},
			methods: {
				change: function () {
					//console.log(`Selected To Year: ${this.selectedYear}`);
					if (vm.fromYearSelector.selectedYear >= vm.toYearSelector.selectedYear){
						vm.toYearSelector.selectedYear = this.years[this.years.indexOf(vm.fromYearSelector.selectedYear) + 1];
					}
					vm.refreshAppData();
				}
			}
		});

		vm.selectedLocation = new Vue({
			el: "#selectedLocation",
			data: {
				location: "",
				state: ""
			}
		});

		if (urlService && urlService.app) {
			//set selected state from url
			let initialSelectedState = Regions.States.find(s => s.StateFIPS === urlService.app.state);
			Vue.set(vm.stateSelector, 'selectedState', initialSelectedState);
			vm.stateSelector.change();

			//set selected region type from 
			// let initialRegionType = urlService.app.regionType === 'county' ? 'counties' : 'watersheds';
			let initialRegionType = 'counties';
			Vue.set(vm.regionTypeSelector, 'regionType', initialRegionType);
			vm.regionTypeSelector.change();

			if (initialRegionType === 'counties') {
				let initialCounty = initialSelectedState.Counties.find(c => c.GeoId === urlService.app.geoid)
				Vue.set(vm.countySelector, 'selectedCounty', initialCounty);
				vm.countySelector.change();
			}/* else {
				let initialWatershed = initialSelectedState.Watersheds.find(w => w.GeoId === urlService.app.geoid)
				Vue.set(vm.watershedSelector, 'selectedWatershed', initialWatershed);
				vm.watershedSelector.change();
			} */

			Vue.set(vm.fromYearSelector, 'selectedYear', urlService.app.fromYear);
			vm.fromYearSelector.change();

			Vue.set(vm.toYearSelector, 'selectedYear', urlService.app.toYear);
			vm.toYearSelector.change();



		}

	}

	refreshAppData() {

		this.dataService.get(
			// this.regionTypeSelector.regionType === 'counties' ? this.countySelector.selectedCounty.GeoId : this.watershedSelector.selectedWatershed.GeoId,
			this.countySelector.selectedCounty.GeoId,
			this.fromYearSelector.selectedYear,
			this.toYearSelector.selectedYear,
			this.regionTypeSelector.regionType,
			this.selectedLocation.state,
			this.selectedLocation.stateFIPS,
			this.selectedLocation.location
		);
	}
}